// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Qnh0D","card__block":"Card_card__block__7JgqR","card__block__price":"Card_card__block__price__86D7b","plus":"Card_plus__6Sg3p","favorite":"Card_favorite__i5KDO"};